import React from "react";
import { cn } from "../../utils/cn";

interface InfoGridProps {
  data: { label: string; value: string }[];
  styles?: string;
}

const InfoGrid = ({ data, styles }: InfoGridProps) => {
  return (
    <div className={cn("grid justify-between gap-5 grid-cols-3", styles)}>
      {data?.map(({ label, value }) => {
        if (!value) return <React.Fragment key={label}></React.Fragment>;

        return (
          <div key={label} className="min-w-0 break-words">
            <p className="text-purple-secondary">{label}</p>
            <p className="break-words text-sm text-wrap overflow-hidden">
              {value}
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default React.memo(InfoGrid);
